module.exports = __webpack_public_path__ + "static/media/wb_dark.4c8d5966.png";